export default function ownerDocument(node) {
    return (node && node.ownerDocument) || document;
}
//# sourceMappingURL=owner-document.js.map